export function errorCallback(error, cb) {
  console.error(error);
  console.trace();
  if (cb) {
    cb(error);
  }
}
